import React from "react";
let PropTypes = React.PropTypes;

class HeaderConFiltro extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      filtro: [],
    };
  }
  componentWillReceiveProps(nextProps) {
    // actualizar el filtro cuando se reciban nuevas propiedades
    this.setState({ filtro: nextProps.filtro });
  }

  onSelect(evt) {
    let valorSeleccionado = evt.target.value;
    this.setState(
      {
        filtro: this.state.filtro.map((opcion) => {
          if (valorSeleccionado === "todas") {
            return {
              seleccionado: true,
              texto: opcion.texto,
              valor: opcion.valor,
            };
          }
          if (valorSeleccionado === "auditorias") {
            return {
              seleccionado: opcion.valor == 0,
              texto: opcion.texto,
              valor: opcion.valor,
            };
          }
          if (valorSeleccionado === "sensores") {
            return {
              seleccionado: opcion.valor > 0,
              texto: opcion.texto,
              valor: opcion.valor,
            };
          }
        }),
      },
      () => this.props.actualizarFiltro(this.state.filtro)
    );
  }
  render() {
    return (
      <div>
        <div
          style={{ display: "flex", flexDirection: "column", width: "120px" }}
        >
          <b className="font-weight-bold">{this.props.nombre}</b>
          <select className="form-control" onChange={this.onSelect.bind(this)}>
            <option value="todas">Todas</option>
            <option value="auditorias">Solo Auditorias</option>
            <option value="sensores">Solo Sensores</option>
          </select>
        </div>
      </div>
    );
  }
}

HeaderConFiltro.propTypes = {
  nombre: PropTypes.string,
  busquedaExacta: PropTypes.bool,
  filtro: PropTypes.arrayOf(PropTypes.object).isRequired,
  // Metodos
  actualizarFiltro: PropTypes.func.isRequired,
  ordenarLista: PropTypes.func,
};
HeaderConFiltro.defaultProps = {
  nombre: "[sin nombre]",
  busquedaExacta: false,
  ordenarLista: null,
};
export default HeaderConFiltro;



// WEBPACK FOOTER //
// ./frontEnd/auditorias/programacion-semanal/CheckboxSensores.jsx